import { ListOptionBase } from "@shared/components";

export const DOCUMENT_REPORT = "DOCUMENT_REPORT";
export const WHO_ACCESSED_DOCUMENTS_REPORT = "WHO_ACCESSED_DOCUMENTS_REPORT";
export const TERMS_ACCEPTANCE_REPORT = "TERMS_ACCEPTANCE_REPORT";
export const WHO_ACCESSED_DATA_ROOMS_REPORT = "WHO_ACCESSED_DATA_ROOMS_REPORT";
export const WHO_ACCESSED_EVENT_REPLAYS_REPORT = "WHO_ACCESSED_EVENT_REPLAYS_REPORT";
export const WHO_ACCESSED_FEATURED_INSIGHTS_REPORT = "WHO_ACCESSED_FEATURED_INSIGHTS_REPORT";
export const DOCUMENTS_MISSING_ENTITLEMENTS = "DOCUMENTS_MISSING_ENTITLEMENTS";
export const DOCUMENTS_DIGEST_DISPATCH_REPORT = "DOCUMENTS_DIGEST_DISPATCH_REPORT";
export const BOUNCE_BACK_REPORT = "BOUNCE_BACK_REPORT";

export const administrationReportsOptions: Array<ListOptionBase> = [
  {
    id: WHO_ACCESSED_DOCUMENTS_REPORT,
    label: "Who Accessed Documents Report",
  },
  {
    id: DOCUMENT_REPORT,
    label: "Document Report",
  },
  {
    id: TERMS_ACCEPTANCE_REPORT,
    label: "Terms & Conditions Acceptance Report",
  },
  {
    id: WHO_ACCESSED_DATA_ROOMS_REPORT,
    label: "Who Accessed Data Rooms Report",
  },
  {
    id: WHO_ACCESSED_EVENT_REPLAYS_REPORT,
    label: "Who Accessed Events Report",
  },
  {
    id: WHO_ACCESSED_FEATURED_INSIGHTS_REPORT,
    label: "Who Accessed Content Library Report",
  },
  {
    id: DOCUMENTS_MISSING_ENTITLEMENTS,
    label: "Documents Missing Entitlements Report",
  },
  {
    id: DOCUMENTS_DIGEST_DISPATCH_REPORT,
    label: "Document Digest Dispatch Report",
  },
  {
    id: BOUNCE_BACK_REPORT,
    label: "Digest Bounce Back Report",
  },
];
